import { setArticleFolderDetailsData, resetArticleFolderDetailsData } from '../../../redux/articleFolderDetailsDataSlice';
import ArticleFolderDetailsContent from './articleFolderDetailsContent';
import { SuccessfullModifyDialog } from '../../SuccessfullModifyDialog';
import ArticleFolderDetailsHeader from './articleFolderDetailsHeader';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useCallback, useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import ArticleItems from './articles/articleItems';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';

const ArticleFolderDetails = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);

    const fetchArticleFolderDetails = useCallback(async () => {
        try {
            const { data, status } = await axios.get(`article-folder/${id}`);
            if ((status === 200 || status === 201) && data) {
                dispatch(setArticleFolderDetailsData(data));
                setLoading(false);
            } else {
                setLoading(false);
                console.warn('Unexpected response status or empty data:', status, data);
            }
        } catch (error) {
            setLoading(false);
            console.error('Erreur lors de la récupération des informations du dossiser :', error);
            CustomErrorLogger(error, 'Erreur dans fetchArticleFolderDetails');
        }
    }, [id, dispatch]);

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Fetch articleFolder details on mount and cleanup on unmount
    useEffect(() => {
        fetchArticleFolderDetails();
        return () => {
            dispatch(resetArticleFolderDetailsData());
        };
    }, [dispatch, fetchArticleFolderDetails]);

    return (
        <Box>
            {loading ?
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '80vh',
                    }}
                >
                    <CircularProgress
                        sx={{
                            '& .MuiCircularProgress-circle': { stroke: '#EA5E00' },
                        }}
                    />
                </Box>
                :
                <Box>
                    <ArticleFolderDetailsHeader />
                    <ArticleFolderDetailsContent />
                    <ArticleItems />
                    <SuccessfullModifyDialog />
                </Box>
            }
        </Box>
    );
}

export default ArticleFolderDetails;